import BaseModel from 'base/model/base_model'

export default BaseModel.extend({
  constructor: function LetterElementModel() {
    BaseModel.apply(this, arguments)
  },

  props: {
    id: [ 'string' ],
    sortId: [ 'number' ],
    type: [ 'string' ],
    metaData: [ 'object' ],
    x: [ 'number' ],
    y: [ 'number' ],
  },
})
